import { render, staticRenderFns } from "./Mint.vue?vue&type=template&id=d47c05dc&scoped=true&"
import script from "./Mint.vue?vue&type=script&lang=js&"
export * from "./Mint.vue?vue&type=script&lang=js&"
import style0 from "./Mint.vue?vue&type=style&index=0&id=d47c05dc&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d47c05dc",
  null
  
)

export default component.exports